import { plans } from "@/config/stripePlans";
import type { OnboardingData } from "./types";

export function validateAccount(d: OnboardingData): boolean {
  return d.accountCreated;
}

export function validateBusiness(d: OnboardingData): boolean {
  return (
    d.businessName.trim().length > 0 &&
    d.contactName.trim().length > 0 &&
    d.phone.trim().length > 0 &&
    d.category.trim().length > 0
  );
}

export function validatePlan(d: OnboardingData): boolean {
  if (!plans[d.selectedPlan]) return false;
  // Early Supporter requires picking at least one comped grant.
  if (d.selectedPlan === "early_supporter") {
    return d.earlySupporterGrants.length > 0;
  }
  return true;
}

export function canProceedFromStep(step: number, d: OnboardingData): boolean {
  switch (step) {
    case 0:
      return validateAccount(d);
    case 1:
      return validateBusiness(d);
    case 2:
      return validatePlan(d);
    default:
      // Connect step (3) is skippable; Review (4) and Finish (5) auto-pass.
      return true;
  }
}
